import { Row } from '@tanstack/react-table'

import { DomainAlerts } from 'features/inventory/domain'
import { Domain } from 'features/inventory/types/domain'
import WorkspaceAlerts from '../../WorkspaceAlerts'
import { WorkspaceForTable } from '../types'
import { isWorkspaceRow } from './utils'

type Props = Row<WorkspaceForTable>

export const AlertsCell = ({ depth, original: { alerts } }: Props) => {
  if (isWorkspaceRow(depth)) {
    return <WorkspaceAlerts alerts={alerts} />
  }

  return <DomainAlerts alerts={alerts as unknown as Domain['alerts']} />
}
